import { Alert, Button, Col, Row } from 'antd';
import TaxInvoiceAccountDetailComponent from '../../components/expenses/TaxInvoiceAccountDetailComponent';
import Title from 'antd/lib/typography/Title';
import CreateTaxInvoiceAccountModal from '../../components/expenses/CreateTaxInvoiceAccountModal';
import {
  createTaxInvoiceAccounts,
  deleteTaxInvoiceAccounts,
  getTaxInvoiceAccounts,
} from '../../api/constlink';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../modules';

interface TaxInvoiceAccountConfigContainerProps {
  enterpriseId: string;
}

function TaxInvoiceAccountConfigContainer({
  enterpriseId,
}: TaxInvoiceAccountConfigContainerProps) {
  const [alertMsg, setAlertMsg] = useState<any>();
  const [taxInvoiceAccount, setTaxInvoiceAccount] = useState<any>();
  const [visibleTaxInvoiceAccountModal, setVisibleTaxInvoiceAccountModal] =
    useState(false);

  const myEnterprise = useSelector(
    (state: RootState) => state.auth.myEnterprise.data,
  );

  useEffect(() => {
    (async () => {
      const _taxInvoiceAccounts = await getTaxInvoiceAccounts({ enterpriseId });
      if (_taxInvoiceAccounts.success && _taxInvoiceAccounts.data.length > 0)
        setTaxInvoiceAccount(_taxInvoiceAccounts.data[0]);
    })();
  }, [enterpriseId]);

  const onDeleteTaxInvoiceAccount = async () => {
    await deleteTaxInvoiceAccounts({
      enterpriseId,
      taxInvoiceAccountId: taxInvoiceAccount.id,
    });
    setAlertMsg({ message: '홈택스 연동을 해지 하였습니다.', type: 'info' });
    setTaxInvoiceAccount(null);
  };

  const openTaxInvoiceAccountModal = () => {
    setVisibleTaxInvoiceAccountModal(true);
  };

  const closeTaxInvoiceAccountModal = () => {
    setVisibleTaxInvoiceAccountModal(false);
  };

  const onCreateTaxInvoiceAccount = async (data: any) => {
    const result = await createTaxInvoiceAccounts({
      enterpriseId,
      data: {
        userName: data.userName,
        userPassword: data.userPassword,
        corporateNumber: myEnterprise?.corporateNumber,
        userId: data.user,
      },
    });
    if (result.success) {
      setTaxInvoiceAccount(result.data);
      setAlertMsg({
        message: '홈택스 계정이 정상적으로 연동 되었습니다.',
        type: 'info',
      });
    } else {
      setAlertMsg({ message: result.message, type: 'error' });
    }
    setVisibleTaxInvoiceAccountModal(false);
  };

  return (
    <>
      {alertMsg && (
        <Alert
          message={`${alertMsg.message}`}
          type={
            alertMsg.type === 'error'
              ? 'error'
              : alertMsg.type === 'warning'
              ? 'warning'
              : 'info'
          }
          closable
          style={{ marginTop: '5px', marginBottom: '5px' }}
        />
      )}

      {taxInvoiceAccount ? (
        <TaxInvoiceAccountDetailComponent
          taxInvoiceAccount={taxInvoiceAccount}
          onDelete={onDeleteTaxInvoiceAccount}
        />
      ) : (
        <>
          <Row
            justify={'center'}
            style={{ marginTop: '40px', marginBottom: '20px' }}
          >
            <Col>
              <Title level={5}>
                전자세금계산서 불러오기 기능을 사용하시려면 홈택스 계정을 연동
                하셔야 합니다.
              </Title>
            </Col>
          </Row>
          <Row justify={'center'}>
            <Col>
              <Button onClick={openTaxInvoiceAccountModal}>
                홈택스 연동하기
              </Button>
            </Col>
          </Row>
        </>
      )}
      {visibleTaxInvoiceAccountModal && (
        <CreateTaxInvoiceAccountModal
          openTaxInvoiceAccountModal={visibleTaxInvoiceAccountModal}
          onCancel={closeTaxInvoiceAccountModal}
          onCreateTaxInvoiceAccount={onCreateTaxInvoiceAccount}
          enterpriseId={enterpriseId}
        />
      )}
    </>
  );
}

export default TaxInvoiceAccountConfigContainer;
